import { SummaryType } from "@ls/grouping-service";
import produce from "immer";
import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import {
  RECEIVE_BETA_DECODES,
  REQUEST_BETA_DECODES,
  SET_DEFINITION,
  SET_DEFINITIONS,
  REQUEST_BETA_DATA,
  RECEIVE_BETA_DATA,
  REQUEST_BETA_SBS_DATA,
  RECEIVE_BETA_SBS_DATA,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";
import { DELETE_COLUMN } from "state/grid/actions";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingBetaDecodes: false,
  betaDecodes: [],
  fetchingBetaData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  betaData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  fetchingBetaSbsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  betaSbsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      return setDefinitionToState(state, action.idx, action.definition);
    }
    case DELETE_COLUMN: {
      return removeDefinitionFromState(state, action.payload);
    }
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.betaData = defaultState.betaData;
      state.betaSbsData = defaultState.betaSbsData;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;
    }

    case REQUEST_BETA_DECODES: {
      state.fetchingBetaDecodes = true;
      state.betaDecodes = defaultState.betaDecodes;
      break;
    }
    case RECEIVE_BETA_DECODES: {
      state.fetchingBetaDecodes = false;
      state.betaDecodes = action.data;
      break;
    }

    case REQUEST_BETA_DATA: {
      state.fetchingBetaData[action.summary] = true;
      state.betaData[action.summary] = defaultState.betaData[action.summary];
      break;
    }
    case RECEIVE_BETA_DATA: {
      state.fetchingBetaData[action.summary] = false;
      state.betaData[action.summary] = action.data;
      break;
    }
    case REQUEST_BETA_SBS_DATA: {
      state.fetchingBetaSbsData[action.summary] = true;
      state.betaSbsData[action.summary] =
        defaultState.betaSbsData[action.summary];
      break;
    }
    case RECEIVE_BETA_SBS_DATA: {
      state.fetchingBetaSbsData[action.summary] = false;
      state.betaSbsData[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
export default reducer;
